import { type IHttpApi } from '@cian/http-api/shared';
import { type ILogger } from '@cian/logger/shared';

import { ResponseError } from '../../errors';
import { prepareNewbuildingLayouts } from '../../mappers/prepareNewbuildingLayouts';
import {
  fetchSearchNewbuildingLayoutsDesktop,
  TSearchNewbuildingLayoutsDesktopResponse,
} from '../../repositories/search-offers/v1/search-newbuilding-layouts-desktop';
import { INewbuildingLayoutsForDesktop } from '../../types/residentialComplexLayouts/layouts/residentialComplexLayouts';

type ISearchNewbuildingLayoutsDesktopParameters = {
  // oxlint-disable-next-line typescript/no-explicit-any
  jsonQuery: any;
  subdomain: string;
  path: string;
};

type IContext = {
  httpApi: IHttpApi;
  logger: ILogger;
};

export async function fetchSearchNewbuildingLayouts(
  { httpApi }: IContext,
  _parameters: ISearchNewbuildingLayoutsDesktopParameters,
): Promise<INewbuildingLayoutsForDesktop> {
  const parameters = { jsonQuery: _parameters.jsonQuery, subdomain: _parameters.subdomain, path: _parameters.path };

  const offersData: TSearchNewbuildingLayoutsDesktopResponse = await fetchSearchNewbuildingLayoutsDesktop({
    httpApi,
    parameters,
  });

  if (offersData.statusCode !== 200) {
    throw new ResponseError({
      domain: 'fetchSearchNewbuildingLayoutsDesktop',
      message: offersData.response.message || '',
      details: {
        error: JSON.stringify(offersData.response.errors),
      },
    });
  }

  return prepareNewbuildingLayouts(offersData.response);
}
